import { useEffect, useState } from 'react';

import { sessionStore } from '~src/state/local';

export const CUSTOMER_ADDRESS = 'customer.address';

const CUSTOMER_RESIDENCE = 'customer.residence';
const CUSTOMER_OUTDOOR_UNIT = 'customer.outdoorUnit';
const CUSTOMER_OFFER = 'customer.offer';

export const SELECTED_PRODUCT_TYPES = 'selectedProductTypes';

export const CALCULATOR_STAGE = 'calculator.stage';

export const useCachedState = <T>(
  key: string,
  initialValue?: T,
  cacheIf?: (value: T) => boolean
): [T | undefined, (value?: T) => void, boolean | undefined] => {
  const [value, setValue] = useState<T | undefined>(initialValue);
  const [hasCachedValue, setHasCachedValue] = useState<boolean>();

  useEffect(() => {
    const cached = sessionStore().get(key) as T | undefined;

    if (!cached) {
      setHasCachedValue(false);
      return;
    }

    if (typeof cached === 'object') {
      if ((Array.isArray(cached) && cached.length === 0) || Object.keys(cached).length === 0) {
        setHasCachedValue(false);
        return;
      }

      if (Object.keys(cached).length === 0) {
        setHasCachedValue(false);
        return;
      }
    }

    if (cacheIf && !cacheIf(cached)) {
      setHasCachedValue(false);
      return;
    }

    setValue(cached);
    setHasCachedValue(true);
  }, []);

  return [
    value,
    (newValue?: T) => {
      if (newValue) {
        sessionStore().set(key, newValue);
      } else {
        sessionStore().clear(key);
      }
      setValue(newValue);
    },
    hasCachedValue,
  ];
};

export const clearFrontendCache = () => {
  sessionStore().clear(CUSTOMER_RESIDENCE);
  sessionStore().clear(CUSTOMER_OFFER);
  sessionStore().clear(CUSTOMER_OUTDOOR_UNIT);
  sessionStore().clear(CALCULATOR_STAGE);
  sessionStore().clear(CUSTOMER_ADDRESS);
};
